module.exports = __webpack_public_path__ + "static/media/tnc.73ff629a.PNG";